import { makeStyles } from '@material-ui/core/styles';

const FeaturedEventStyles =
makeStyles((theme) => ({

    featuredEventImgContainerStyles: {
        width: "66%",
        verticalAlign: "middle",
        display: "flex",
        [theme.breakpoints.down('sm')]: {
            width: "100%",
            order: 1,
            textAlign: "center",
        },
    },

    featuredEventContainer: {
        display: "flex",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
        },
    },

    featuredEventSummaryContainer: {
        padding: "50px",
        width: "34%",
        [theme.breakpoints.down('sm')]: {
            width: "100%",
            order: 2,
        },
    },

    featuredEventTitleMargin: {
        marginBottom: "50px",
    },

    featuredEventButtonStyle: {
        marginTop: "50px",
        padding: "5px 25px",
    },
}));

export default FeaturedEventStyles;
